module.exports = __webpack_public_path__ + "media/site_templates/www.fixholeinwall.com.au/images/our_services_1-6aaeb17c8121166b42bcec8db0094836.jpg";